<template>{{ display }}</template>

<script>
// https://stackoverflow.com/questions/6108819/javascript-timestamp-to-relative-time
import RelativeTime from '@yaireo/relative-time'
const relativeTime = new RelativeTime();

export default {
	data : () => ({
		display : ''
	}),
	props : {
		datetime : {
			type		: String,
			required	: false,
			default		: Date.now()
		},
	},
    mounted(){
		this.getTime()
		setInterval(() => this.getTime(),60000)
	},
	methods : {
		getTime(){
			this.display = relativeTime.from(Date.parse(this.datetime));
		}
	}
};

</script>